export const API_NAPCLASS =
  process.env.REACT_APP_API_NAPCLASS_PRO ??
  // "http://192.168.1.22:6060/api";
  "https://netappperu.xyz/api";

export const API_POSTULATION = process.env.REACT_APP_API_POSTULATION;
